
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import DirectorSection from './components/DirectorSection';
import TestimonialsSection from './components/TestimonialsSection';
import RecruitmentSection from './components/RecruitmentSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <DirectorSection />
        <TestimonialsSection />
        <RecruitmentSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
